// ChatHeader.tsx
import React from "react";
import { useDispatch } from "react-redux";
import { miniChat, closeChat, toggleSize } from "./chatSlice";
import { Minimize, Close, FullScreen } from "./icons";
import styles from "./index.module.css";

import { useTranslation } from "react-i18next";

interface ChatHeaderProps {
    onClose: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose }) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const handleClose = () => {

        i18n.changeLanguage('pt')
        dispatch(closeChat());
        onClose();
    };

    return (
        <div className={styles.header}>
            <div className={styles.titleContainer}>
                <h6 className={styles.title}>{t("settings.title")}</h6>
            </div>
            <div className={styles.imageContainer}>
                <img src="/BARRA_MADEIRA_PRR_mono-01.png" alt="Banner" className={styles.bannerImage} />
            </div>
            <div className={styles.buttons}>
                <div className={styles.fullScreenWrapper}> 
                    <button className={styles.button} onClick={() => dispatch(toggleSize())}>
                        <FullScreen />
                    </button>
                </div>
                <button className={styles.button} onClick={() => dispatch(miniChat())}>
                    <Minimize />
                </button>
                <button className={styles.button} onClick={handleClose}>
                    <Close />
                </button>
            </div>
        </div>
    );
};

export default ChatHeader;